import React from "react";

const IFCLookupList_Pagination = ({ totalPages, currentPage, goToPage }) => {
    const paginationItems = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i++) {
            paginationItems.push(
                <button
                    key={i}
                    className={`mx-1 px-4 py-2 border rounded-md ${i === currentPage ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                    onClick={() => goToPage(i)}
                >
                    {i}
                </button>
            );
        }
    } else {
        // Always show first page
        paginationItems.push(
            <button
                key={1}
                className={`mx-1 px-4 py-2 border rounded-md ${currentPage === 1 ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                onClick={() => goToPage(1)}
            >
                1
            </button>
        );

        if (currentPage > 3) {
            paginationItems.push(<span key="start-ellipsis" className="mx-1 px-2">...</span>);
        }

        // Show pages around current page
        let startPage = Math.max(2, currentPage - 2);
        let endPage = Math.min(totalPages - 1, currentPage + 2);

        for (let i = startPage; i <= endPage; i++) {
            paginationItems.push(
                <button
                    key={i}
                    className={`mx-1 px-4 py-2 border rounded-md ${i === currentPage ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                    onClick={() => goToPage(i)}
                >
                    {i}
                </button>
            );
        }

        if (currentPage < totalPages - 2) {
            paginationItems.push(<span key="end-ellipsis" className="mx-1 px-2">...</span>);
        }

        // Always show last page
        paginationItems.push(
            <button
                key={totalPages}
                className={`mx-1 px-4 py-2 border rounded-md ${currentPage === totalPages ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                onClick={() => goToPage(totalPages)}
            >
                {totalPages}
            </button>
        );
    }

    return (
        <div className="flex items-center justify-between mt-5">
            <button
                className={`px-4 py-2 border rounded-md ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
            >
                Previous
            </button>
            <div className="hidden md:flex">{paginationItems}</div>
            <button
                className={`px-4 py-2 border rounded-md ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`}
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                Next
            </button>
        </div>
    );
};

export default IFCLookupList_Pagination;
